import React from "react";
import { Link } from "react-router-dom";
import ROUTES from "../../utils/routes";
import { LazyLoadImage } from "react-lazy-load-image-component";

import {
  convertToPrice as getPrecio,
  encodeNumber as nToString,
} from "../../API/request";

const SliderItem = ({ articulo, showPrice, categoriaSelect }) => {
  return (
    <>
      <div className="item--slide">
        <Link to={ROUTES.DETAILSEMPTY + nToString(articulo.id)}>
          <div className="item--slide--image">
            <LazyLoadImage
              alt={articulo.img}
              src={process.env.REACT_APP_IMAGE_ARTICLES_PATH + articulo.img}
            />
          </div>
        </Link>
        <div className="item--slide--info">
          <hr className="col-8 offset-2" />
          <span className="item--slide--info--name">
            {articulo.nombre.replace(/\\"/g, "")}
          </span>
          <div className="item--slide--info--detail">
            {showPrice && <span>{getPrecio(articulo.precioPublico)}</span>}
            <Link to={ROUTES.DETAILSEMPTY + nToString(articulo.id)}>
              <u>Ver detalles</u>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SliderItem;
